import './Button.css'

let Button = (props) => {
    let dynamicClass
    if (props.class) {
        dynamicClass = props.class + ' buttons'
    } else {
        dynamicClass = 'buttons'
    }
    let download = props.download || ''
    let btnId = props.btnId || ''
    let anchorId = props.anchorId || ''
    console.log(props.addLink, 'prv');
    let addLink = props.addLink
    console.log(addLink, 'addlink');
    function downloadFile() {
        const url = props.link
        const link = document.createElement('a');
        link.href = url;
        link.download = 'resume.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    return (
        <div className={dynamicClass} id={btnId}>
            <a href={props.link} target='_blank' onClick={download ? downloadFile : ''} id={anchorId}  >{props.text}</a>
        </div>
    )
}

export default Button

// resume-button-1